import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/styles'
import { mdiAlertRhombusOutline } from '@mdi/js'
import CircularHighlightedIcon from 'components/circular-highlighted-icon'
import Button from '@material-ui/core/Button'
import themes, { extendTheme } from 'themes'
import { useSupportContactActions } from 'lib/support'

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: '800px',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  infoBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(12),
    borderRadius: theme.spacing(1),
    border: '1px solid #E0E0E0',
    [theme.breakpoints.only('xs')]: {
      border: 'unset',
      padding: theme.spacing(1),
    },
  },
  text: {
    marginBottom: theme.spacing(3),
  },
}))

const SponsorshipRemoved = () => {
  const classes = useStyles()
  const { openSupport } = useSupportContactActions()
  const isIntercomOverride = !!window.location.search.match(/intercomOverride/i)

  return (
    <ThemeProvider
      theme={extendTheme({
        ...themes.pgaCoach,
        ...(isIntercomOverride ? themes.intercom : {}),
      })}
    >
      <Container className={classes.container}>
        <Box className={classes.infoBlock}>
          <CircularHighlightedIcon icon={mdiAlertRhombusOutline} mdi={true} />
          <Typography
            variant="h6"
            style={{ marginBottom: '12px', marginTop: '12px' }}
          >
            Sponsorship Removed
          </Typography>
          <Typography
            variant="body1"
            align="center"
            color="textSecondary"
            className={classes.text}
          >
            Your sponsorship to use PGA Coach has been removed. If you think
            this is a mistake, contact your PGA Coach sponsor to resend a new
            sponsorship.
          </Typography>
          <Button
            color="primary"
            variant="contained"
            style={{ marginBottom: '12px' }}
            onClick={() => {
              openSupport()
            }}
          >
            Contact Support
          </Button>
          <Button
            color="primary"
            target="_blank"
            href="https://docs.google.com/forms/d/e/1FAIpQLSd_n2qYEcQMXOyIufoBdi9__cEKR8akaZZ2SzwOwk4HyJh3Rw/viewform"
          >
            Request Account Data
          </Button>
        </Box>
      </Container>
    </ThemeProvider>
  )
}

export default SponsorshipRemoved
